import {httpi} from 'lib/httpAxios'

export default {
  /** Inicio Aurus - TI : WCR **/
  retrieveTracking (data) {
    return httpi.post(`/Integration/Tracking/OrderList`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrievePointTracking (data) {
    return httpi.post(`/Integration/Tracking/LocationCurrent`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveUbigeoList (data) {
    return httpi.post(`/Integration/Master/UbigeoList`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveOrderTypeList () {
    return httpi.post(`/Integration/Master/OrderTypeList`, {})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveStatusList () {
    return httpi.post(`/Integration/Master/StatusList`, {})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveZoneList () {
    return httpi.post(`/Integration/Master/ZoneList`, {})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveOrderFollowUpList (data, page, size) {
    return httpi.post(`/Integration/Query/OrderFollowUpList/${page}/${size}`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveOrderDetail (data) {
    return httpi.post(`/Integration/Query/OrderDetail`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  },
  retrieveGenerateReport (data) {
    return httpi.post(`/Integration/Query/GenerateReport`, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error.response))
  }

  /** Fin Aurus - TI : WCR **/
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/tracking.js